import { stepInit } from './Step'

const clickListeners = new Map()
const correctAnswers = new Map()

export const initEditorQuiz = (elementRef, t, setAnswerInit) => {
  findAndUncheckCorrectAnswer(elementRef.current)
  setupQuizQuestion(elementRef.current, t)
  stepInit()
  setAnswerInit(true)
}

export const clearClickListeners = () => {
  clickListeners.clear()
}

export const clearCorrectAnswers = () => {
  correctAnswers.clear()
}

export const findAndUncheckCorrectAnswer = (element) => {
  const checkedInput = element.querySelector('input[type="radio"]:checked')

  element
    .querySelector('.knowledge-quiz-question')
    .classList.add('knowledge-quiz-question--unanswered')

  if (checkedInput) {
    checkedInput.checked = false
    correctAnswers.set(element, checkedInput)
    return true
  }

  return false
}

export const setButtonVisibility = (element, hidden) => {
  const button = element.querySelector(
    '.knowledge-quiz-question input[type="button"]'
  )
  if (button) {
    button.hidden = hidden
  }
}

export const setButtonDisabledIdAndText = (
  element,
  disabled = false,
  id,
  text
) => {
  const button = element.querySelector(
    '.knowledge-quiz-question input[type="button"]'
  )
  if (button) {
    button.disabled = disabled
    if (id) {
      button.id = id
    }
    if (text) {
      button.value = text
    }
  }
}

export const createFallbackFeedbackItem = (element, isCorrect, t) => {
  const el = document.createElement('div')
  const headerBlurb = isCorrect
    ? t('quiz.correct_blurb')
    : t('quiz.wrong_blurb')
  const listItem = `<li class="knowledge-quiz-question__feedback-item">
      <p>${headerBlurb}</p>
    </li>`
  el.innerHTML = listItem
  const node = el.firstChild

  let feedback = element.querySelector('.knowledge-quiz-question__feedback')
  if (!feedback) {
    const tempEl = document.createElement('div')
    tempEl.innerHTML = '<ul class="knowledge-quiz-question__feedback"></ul>'
    const parent = element.querySelector('.knowledge-quiz-question')
    const button = parent.querySelector('input[type="button"]')
    parent.insertBefore(tempEl.firstChild, button)
    feedback = element.querySelector('.knowledge-quiz-question__feedback')
  }

  feedback.appendChild(node)

  return node
}

export const addFeedbackIcon = (feedBackItem, isCorrect, t) => {
  if (
    feedBackItem.querySelector(
      '.knowledge-quiz-question__feedback-item-header'
    ) === null
  ) {
    const el = document.createElement('div')
    const headerText = isCorrect ? t('quiz.correct') : t('quiz.wrong')
    const span = `<span class="knowledge-quiz-question__feedback-item-header">${headerText}</span>`
    el.innerHTML = span

    feedBackItem.prepend(el.firstChild.cloneNode(true))
  }
  if (isCorrect) {
    feedBackItem.classList.add(
      `knowledge-quiz-question__feedback-item--correct`
    )
  }
}

export const showAnswerFeedback = (
  element,
  correctAnswer,
  selectedAnswer,
  t
) => {
  element
    .querySelector('.knowledge-quiz-question')
    .classList.remove('knowledge-quiz-question--unanswered')

  const feedBackClass = 'knowledge-quiz-question__feedback-item'
  const feedbackItems = element.querySelectorAll(`.${feedBackClass}`)
  let feedBackItem

  feedbackItems.forEach((item) => {
    if (item.id === `feedback-for-${selectedAnswer.id}`) {
      feedBackItem = item
    }
    item.classList.remove(`${feedBackClass}--show`)
  })

  feedBackItem = feedBackItem || element.querySelector('#feedback')

  feedBackItem =
    feedBackItem ||
    createFallbackFeedbackItem(element, selectedAnswer === correctAnswer, t)

  if (feedBackItem) {
    addFeedbackIcon(feedBackItem, selectedAnswer === correctAnswer, t)
    feedBackItem.classList.add(`${feedBackClass}--show`)
  }
}

const resetFeedBack = (element) => {
  element
    .querySelector('.knowledge-quiz-question')
    .classList.add('knowledge-quiz-question--unanswered')
}

export const disableChoices = (element) => {
  const inputs = element.querySelectorAll('input[type="radio"]')
  inputs.forEach((input) => {
    input.disabled = true
  })
}

export const initAnswerHandler = (
  element,
  getOrderAndAnswerStatus,
  checkLast,
  resultHandler,
  nextQuestion,
  t
) => {
  const checkedInput = element.querySelector('input[type="radio"]:checked')
  addClickHandler(
    element,
    correctAnswers.get(element),
    checkedInput || null,
    getOrderAndAnswerStatus,
    resultHandler,
    nextQuestion,
    checkLast,
    t
  )
}

const removeClickHandler = (element) => {
  if (clickListeners.has(element)) {
    element.removeEventListener('click', clickListeners.get(element))
    clickListeners.delete(element)
  }
}

const addClickHandler = (
  element,
  correctAnswer,
  selectedAnswer,
  getOrderAndAnswerStatus,
  resultHandler,
  nextQuestion,
  checkLast,
  t
) => {
  const clickHandler = (event) => {
    if (!correctAnswer) {
      return
    }
    const clicked = event.target
    if (clicked.tagName.toLowerCase() !== 'input') {
      return
    }
    if (clicked.type === 'button' && selectedAnswer) {
      if (clicked.id === 'quiz-next') {
        removeClickHandler(element)
        nextQuestion()
      } else {
        const [order, answered] = getOrderAndAnswerStatus(
          parseInt(selectedAnswer.value, 10)
        )
        const data = {
          answer: selectedAnswer.value,
          correct: selectedAnswer === correctAnswer,
          order,
        }
        showAnswerFeedback(element, correctAnswer, selectedAnswer, t)
        if (selectedAnswer === correctAnswer) {
          if (checkLast()) {
            setButtonDisabledIdAndText(
              element,
              false,
              'quiz-next',
              t('quiz.final')
            )
          } else {
            setButtonDisabledIdAndText(
              element,
              false,
              'quiz-next',
              t('quiz.next')
            )
          }
        } else {
          setButtonDisabledIdAndText(
            element,
            true,
            'quiz-submit',
            t('quiz.submit')
          )
          setButtonVisibility(element, true)
        }
        removeClickHandler(element)
        addClickHandler(
          element,
          correctAnswer,
          clicked,
          getOrderAndAnswerStatus,
          resultHandler,
          nextQuestion,
          checkLast,
          t
        )
        if (order >= 0 && !answered) {
          resultHandler(data)
        }
      }
    } else {
      removeClickHandler(element)
      addClickHandler(
        element,
        correctAnswer,
        clicked,
        getOrderAndAnswerStatus,
        resultHandler,
        nextQuestion,
        checkLast,
        t
      )
      resetFeedBack(element)
      setButtonDisabledIdAndText(
        element,
        false,
        'quiz-submit',
        t('quiz.submit')
      )
      setButtonVisibility(element, false)
    }
  }
  removeClickHandler(element)
  element.addEventListener('click', clickHandler, false)
  clickListeners.set(element, clickHandler)
}

export const setupQuizQuestion = (element, t) => {
  setButtonDisabledIdAndText(element, true, 'quiz-submit', t('quiz.submit'))
}
